/**
 * Keep Ghost's native comments thread on the page's colour scheme.
 *
 * The thread renders in an iframe and does not follow the theme toggle on its
 * own: in `mode="auto"` comments-ui samples the mount's computed text colour
 * once, then re-checks only when the mount's OWN class/style attributes
 * mutate. Flipping `data-theme` on <html> changes neither, so the thread
 * keeps the scheme it booted with. The script tag {{comments}} injects IS
 * watched (comments-ui rebuilds its options on any attribute change), so
 * writing the resolved scheme there switches the thread live.
 * querySelectorAll never reaches an inert copy inside a <template>, which
 * keeps mode="auto" and self-detects if a lazy mount ever clones it.
 */
export function syncCommentsScheme(dark) {
  document.querySelectorAll('script[data-ghost-comments]').forEach((el) => {
    el.dataset.colorScheme = dark ? 'dark' : 'light';
  });
}
